export default __webpack_public_path__ + "static/media/tvtorre.a32d8e95.png";